<template>
  <div class="articles-widget grid">
    <div class="article-header">
      <WidgetHeading
        :is-first="isFirst"
        :content="widget.title"
        class="title t-h2"
      />
      <div class="description t-p-m-160" v-html="nbsp(widget.description)" />
    </div>
    <div class="list">
      <ArticleCardWide
        v-for="item in widget.items"
        :key="item.id"
        :item="item"
      />
    </div>
    <div class="button-wrapper">
      <BaseButton
        :tag="NuxtLink"
        :to="
          localePath({
            name: 'slug',
            params: { slug: widget.link_to_all }
          })
        "
        color="outline-black"
        size="l"
        :text="t('all-posts')"
        class="button"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { NuxtLink } from '#components'
import type { PublicArticlesWidget } from '@/service/__generated-api'
import type { Widget } from '@/types/utils'

const { t } = useI18n()
const localePath = useLocalePath()
defineProps<Widget<PublicArticlesWidget>>()
</script>

<style lang="scss" scoped>
.article-header {
  @include flex-col;
  grid-row: 1 / 2;
  grid-column: 2 / 25;
  gap: rem(32px);
  margin-bottom: rem(52px);

  @include media-up(s-lg) {
    flex-direction: row;
    gap: rem(80px);
  }
}

.title {
  width: 100%;

  @include media-up(s-lg) {
    max-width: rem(432px);
  }

  @include media-up(lg) {
    max-width: rem(560px);
  }

  @include media-up(xl) {
    max-width: rem(520px);
  }
}

.description {
  width: 100%;
  margin-left: auto;

  @include media-up(s-lg) {
    max-width: rem(432px);
  }

  @include media-up(lg) {
    max-width: rem(560px);
  }

  @include media-up(xl) {
    max-width: rem(520px);
  }
}

.list {
  @include column(xs, 12);
  @include flex-col;
  row-gap: rem(12px);
}

.button-wrapper {
  @include column(xs, 12);
  display: flex;
  margin-top: rem(52px);
}
</style>
